import { connect } from 'react-redux';
import { mapValues } from 'lodash';

import money from '../../lib/money';

import PurchaseFeesDisclaimer from '../../components/purchase-claim/purchase-fees-disclaimer';

const mapStateToProps = ({ purchases }) => {
  const purchase = purchases.byId[purchases.current];
  const fees = mapValues(purchase.feesStructure.consumerFees, (f) => {
    if (f && typeof f === 'object' && f.hasOwnProperty('amountCents')) {
      return money(f);
    }
    return f;
  });

  return {
    applyConsumerFeeToOrganizer: purchase.applyConsumerFeeToOrganizer,
    fees: fees,
  };
};

export default connect(mapStateToProps)(PurchaseFeesDisclaimer);



// WEBPACK FOOTER //
// ./src/desktop/containers/purchase-claim/purchase-fees-disclaimer.container.js